import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import PersetujuanMarkerSiteSvc from "@/services/PersetujuanMarkerSite";

@Module({ store, dynamic: true, namespaced: true, name: "persetujuan-marker-site" })
class PersetujuanMarkerSiteModule extends VuexModule {
  items: any[] = [];
  currentItem: any = null;
  loading = false;
  masters: any = {
    sisi: [],
    body_map_views: [],
    pengecualian: [],
    jenis_anestesi: [],
    klasifikasi_operasi: [],
    kelas_perawatan: [],
    penanda_jenis: [],
    tanda_jenis: [],
    lokasi_penandaan_kontekstual: [],
    saksi_pasien_hubungan: [],
    saksi_rs_jabatan: [],
    dpjp_decision: [],
  };

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_MASTERS(val: any) {
    this.masters = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanMarkerSiteSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanMarkerSiteSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadMasters() {
    if (this.masters.body_map_views && this.masters.body_map_views.length > 0) return;
    try {
      const dt = await PersetujuanMarkerSiteSvc.getMasters();
      this.SET_MASTERS(dt.data.data || this.masters);
    } catch {
      // keep empty
    }
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
  }
}

export const storePersetujuanMarkerSite = getModule(PersetujuanMarkerSiteModule);
